import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { CanActivateFn, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';

export const acceptInvitationAuthGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const auth = inject(Auth);

  const u = await firstValueFrom(user(auth));

  if (!u) {
    const returnUrl = route.url.map((segment) => segment.path).join('/');
    notify('Please sign in to accept this invitation.', 'warning', 3000);
    return router.createUrlTree(['/sign-in'], {
      queryParams: { returnUrl: `/${returnUrl}` },
    });
  }

  return true;
};
